import CheckIcon from '@mui/icons-material/Check';
import { Stack, Typography } from '@mui/material';
import { LinkedinAccountSyncStages } from 'features/co-pilot/linkedin-accounts/linkedin-accounts.types';
import PaiDotLoader from 'features/ui/base-components/pai-dot-loader';
import _ from 'lodash';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  activeSyncStage: LinkedinAccountSyncStages | null;
}

const SyncStagesStepper: React.FC<Props> = ({ activeSyncStage }) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  const stagesArray = _.map(LinkedinAccountSyncStages, (stage) => stage);

  return (
    <Stack className={classes.syncStagesStepper} direction={'row'} justifyContent={'center'}>
      <Stack direction={'column'} sx={{ width: '100%' }}>
        {stagesArray.map((stage, index) => {
          const isActive = index <= stagesArray.findIndex((stage) => stage === activeSyncStage);

          return (
            <Stack key={stage} className={classes.stage} direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
              <Typography className={cx(classes.stageName, { [classes.active]: isActive })}>{t(stage)}</Typography>
              {isActive ? (
                stage === activeSyncStage ? (
                  <PaiDotLoader size={'small'} inline={true} />
                ) : (
                  <CheckIcon className={cx(classes.icon, { [classes.active]: isActive })} />
                )
              ) : null}
            </Stack>
          );
        })}
      </Stack>
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  syncStagesStepper: {
    width: '100%',
  },
  stage: {
    width: '100%',
    padding: '8px 16px',
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.backgrounds.main,
    },
  },
  stageName: {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.greys.medium,
  },
  icon: {
    color: theme.palette.greys.medium,
    fontSize: theme.typography.pxToRem(20),
  },
  active: {
    color: theme.palette.primary.main,
  },
}));

export default SyncStagesStepper;
